import { marker } from "leaflet";
import { forwardRef, useEffect, useState } from "react";

const InstitutionItem = forwardRef(
  (
    {
      etablissement,
      selectedInstitution,
      setSelectedInstitution,
      filters,
      setMapScreen,
      scrollbarRef,
      allEtablissements,
      filtersKeys,
    },
    ref
  ) => {
    const [isSelected, setIsSelected] = useState(false);

    //--- Get overlayScrollbar Instance from the parent component
    let scrollbarInstance = {};
    if (scrollbarRef.current) {
      scrollbarInstance = scrollbarRef.current._osInstance;
    }

    //--- Scroll the selected institution to the top
    const scrollTo = (etablissementArray, idToCompare, e) => {
      const i = etablissementArray.findIndex((elt) => elt.id == idToCompare);
      scrollbarInstance.scroll(e.currentTarget, 500);
    };

    //--- Get institution color & icon
    let filterColor = "";
    let filterIcon = "";
    filtersKeys.forEach((filtersKey) => {
      filters[filtersKey].values.forEach((value) => {
        if (value.slug === etablissement[filtersKey][0]) {
          filterColor = value.color;
          filterIcon = value.icon;
        }
      });
    });

    //--- Control if current item is active or not
    useEffect(() => {
      if (selectedInstitution) {
        if (selectedInstitution.id === etablissement.id) {
          setIsSelected(true);
          document.body.classList.add("no-scroll");
          setMapScreen(true);
        } else {
          setIsSelected(false);
        }
      } else {
        setIsSelected(false);
      }
    }, [selectedInstitution]);

    //--- Trigger auto-scroll, set the selected item state, handle if institution info pop-up has to be displayed
    const handleShowInstitution = (etablissement, e) => {
      scrollTo(allEtablissements, etablissement.id, e);
      setSelectedInstitution((prev) => {
        if (prev) {
          if (prev.id === etablissement.id) {
            return null;
          } else {
            return etablissement;
          }
        } else {
          return etablissement;
        }
      });
    };

    //---- Get filter key name dynamically, works when there's a single filter
    let filterSlugKey = [];
    if (Object.keys(filters)) {
      filterSlugKey = Object.keys(filters);
    }

    return (
      <div
        className={`cdg-inst-item ${isSelected ? "active" : ""}`}
        key={etablissement.id}
        onClick={(e) => handleShowInstitution(etablissement, e)}
        ref={ref}
        style={{ "--filter-color": filterColor ? filterColor : "black" }}
      >
        {filterIcon && <div className="cdg-inst-item__icon" dangerouslySetInnerHTML={{ __html: filterIcon }}></div>}
        <div className="cdg-inst-item__wrapper d-flex flex-column" data-itemid={`${etablissement.id}`}>
          {etablissement.name && <div className="cdg-inst-item__name">{etablissement.name}</div>}
          {etablissement.typeInfos[0].address && (
            <div className="cdg-inst-item__address">{etablissement.typeInfos[0].address}</div>
          )}
        </div>

        <div className="show-more__wrapper" style={{ color: filterColor ? filterColor : "#A99993" }}>
          VOIR PLUS
          <svg fill={filterColor ? filterColor : "#A99993"} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 500">
            <path d="M351.29 133.4c-5.86-5.86-15.36-5.86-21.21 0-5.86 5.86-5.86 15.36 0 21.21l87.32 87.32H46.39c-8.28 0-15 6.72-15 15s6.72 15 15 15H417.4l-87.32 87.32c-5.86 5.86-5.86 15.36 0 21.21 2.93 2.93 6.77 4.39 10.61 4.39s7.68-1.46 10.61-4.39l123.53-123.53L351.3 133.4z" />
          </svg>
        </div>
      </div>
    );
  }
);

export default InstitutionItem;
